import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Icon } from "@/lib/icons";
import { Button, Input } from "@/components/kit";

export default function MemberPins() {
  const [q, setQ] = useState("");
  const [results, setResults] = useState([]);
  const [pins, setPins] = useState({});

  const search = async () => {
    const r = await api.get("/membership/directory", { params: { q, limit: 20 } });
    setResults(r.data.members);
  };
  const view = async (id) => {
    try { const r = await api.get(`/membership/members/${id}/pin`); setPins((p) => ({ ...p, [id]: r.data.pin })); }
    catch (e) { toast.error(e.response?.data?.detail || "No access"); }
  };
  const reset = async (id) => {
    try { const r = await api.post(`/membership/members/${id}/pin/reset`); setPins((p) => ({ ...p, [id]: r.data.pin })); toast.success("PIN reset"); }
    catch (e) { toast.error(e.response?.data?.detail || "No access"); }
  };

  return (
    <div className="max-w-2xl" data-testid="member-pins-page">
      <h1 className="font-zilla text-3xl sm:text-4xl font-semibold mb-1">Member PINs</h1>
      <p className="text-[16px] text-ink/70 mb-5">Look up a member to view or reset their check-in PIN. Every view and reset is logged.</p>

      <div className="flex gap-2 mb-4">
        <Input data-testid="pin-search" placeholder="Search name, email, or #…" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && search()} className="flex-1" />
        <Button data-testid="pin-search-btn" onClick={search} className="px-5">Search</Button>
      </div>

      <div className="bg-cream border border-ink/15 rounded-xl overflow-hidden" data-testid="pin-results">
        {results.length === 0 && <div className="p-10 text-center text-ink/55 text-[16px]">Search for a member above.</div>}
        {results.map((m) => (
          <div key={m.member_id} data-testid={`pin-result-${m.member_number}`} className="flex items-center justify-between gap-3 px-5 py-4 border-b border-ink/8 last:border-0">
            <div>
              <div className="text-[15px] font-semibold">{m.name} <span className="font-mono text-[12px] text-ink/45">{m.member_number}</span></div>
              <div className="text-[13px] text-ink/60">{m.email}</div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              {pins[m.member_id] && <span data-testid={`pin-shown-${m.member_number}`} className="font-mono text-lg tracking-widest bg-ink text-cream px-3 py-1 rounded">{pins[m.member_id]}</span>}
              <Button variant="secondary" data-testid={`pin-view-${m.member_number}`} onClick={() => view(m.member_id)} className="min-h-[40px] py-2 px-3 text-[13px]">View</Button>
              <Button variant="danger" data-testid={`pin-reset-${m.member_number}`} onClick={() => reset(m.member_id)} className="min-h-[40px] py-2 px-3 text-[13px]">Reset</Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
